module.exports = __webpack_public_path__ + "static/img/边11.5873e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边11.png
// module id = LaKi
// module chunks = 2